import { useEffect, useContext } from "react";
import Header from "./Header";
import useState from "react-usestateref";
import authservices from "../services/authservices";
import { Link } from "react-router-dom";
import SubFooter from "./SubFooter";
import { useTranslation } from "react-i18next";
import { UserContext } from "../contexts/UserContext";
import i18n from "../translate/i18n";
const APIKey = () => {
  const [userAuth, setAuth, userAuthref] = useState(false);

  useEffect(() => {
    getSitedata();
  }, []);

  const [siteDatacomes, setSiteData] = useState("");
  const { t } = useTranslation();

  const getSitedata = async () => {
    try {
      const data = await authservices.getsitedata();
      if (data.status == true) {
        setSiteData(data.data);
        // console.log(data, "=-=-=get site datas =-=-", data.data);
      }
    } catch (error) { }
  };

  const [i18nextLngs, seti18nextLngs] = useState(
    localStorage.getItem("i18nextLng") || "en" || "et" || "fi"
  );
  const { i18nextLng } = useContext(UserContext);
  useEffect(() => {
    if (i18nextLng === "en") {
      i18n.changeLanguage(i18nextLngs);
      document.documentElement.lang = i18nextLngs;
      localStorage.setItem("i18nextLng", i18nextLngs);
    }
  }, [i18nextLng]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <>
      <main className="wyscale_landing_main">
        <Header />
      </main>

      <section className="dashboard_content_section">
        <div className="container">
          <div className="smart_dashboard_content" id="terms-condition">
            <h2>{t("APIKey")}</h2>
            <div className="row">
              <div className="col-lg-12">
                <div className="dash_board_profile_content">
                  <div className="contentpage">
                    <h3>{t("AnAPIKey_Ques")}</h3>
                    <p>{t("AnAPIkey_Answer")}</p>
                    <p>{t("AnAPIkey_Answer_2")}</p>

                    <h3>{t("APIKeywork")}</h3>
                    <p>{t("APIKeyWork_follows")}</p>
                    <ul>
                      <li>{t("ApI_Key_Point1")}</li>
                      <li>{t("ApI_Key_Point2")}</li>
                      <li>{t("ApI_Key_Point3")}</li>
                      <li>{t("ApI_Key_Point4")}</li>
                      <li>{t("ApI_Key_Point5")}</li>
                    </ul>
                    <p>{t("Binarge_custody")}</p>
                    {/* <h4>NOTICE:</h4> */}

                    <h3>{t("UserBenefits")}</h3>
                    <h3>1. {t("FullControlOverYourFunds")}</h3>

                    <p>{t("YouKeepYourCrypto")}</p>
                    <h3>2. {t("SafeAndTransparentUse")}</h3>

                    <p>{t("APIConnection")}</p>
                    <h3>3. {t("AutomatedTrading")}</h3>

                    <p>{t("WithTheAPI")}</p>

                    <h3>4. {t("EasyToActivateAndManage")}</h3>

                    <p>{t("YouCanRemove")}</p>

                    <h3>{t("HowToCreateAnAPIKey")}</h3>
                    <p>1. {t("Logintoyourexchange")}</p>
                    <p>2. {t("API_Management")}</p>
                    <p>3. {t("Create_anew_API_key")}</p>
                    <p>4. {t("Following_permissions")}</p>

                    <h3>{t("Allowed")}</h3>
                    <ul>
                      <li>{t("SpotTrading")}</li>
                      <li>{t("Margin_Trading")}</li>
                      <li>{t("Universal_Transfer")}</li>
                    </ul>

                    <h3>{t("Not_Allowed")}</h3>
                    <ul>
                      <li>{t("Withdrawals")}</li>
                      <li>{t("External_Transfers")}</li>
                      <li>{t("Internal_Transfers")}</li>
                      <li>{t("Futures_Trading")}</li>
                      <li>{t("Wallet_Management")}</li>
                      <li>{t("API_withDrawal")}</li>
                    </ul>

                    <h3>{t("Recommeded")}</h3>
                    <ul>
                      <li>{t("IP_Restriction")}</li>
                      <li>{t("Secret_Key")}</li>
                    </ul>

                    <h3>{t("Non-Custodial_SecurityModel")}</h3>
                    <p>{t("sm_follows")}</p>
                    <ul>
                      <li>{t("withdraw_funds")}</li>
                      <li>{t("transfer_funds")}</li>
                      <li>{t("Modify_your_assets")}</li>
                      <li>{t("Acess_privateKey")}</li>
                      <li>{t("Balances_wallet")}</li>
                    </ul>
                    <p>{t("no_custody_rights")}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <SubFooter />
    </>
  );
};

export default APIKey;
